'use client'
import type { ReactNode, FC } from 'react'
import styled from 'styled-components'
import { useMount } from '@/hooks'
import { mq, vw } from '@/styles'
// import { NAVBAR_HEIGHTS } from './commons/layout/Navbar'
import { SliderFlickity } from './commons'

type Props = {
  title: string
  slides: ReactNode[]
}

const staticOptions = {
  draggable: true,
  pageDots: false
}

export const SectionNavLinks:FC<Props> = ({ title, slides}) => {
  const isMount = useMount()

  return (
    <SectionLinksSlider className={`${slides?.length > 0 ? '' : 'empty'}`} aria-labelledby='s-links-title' $isMount={isMount}>
      <h2 id='s-links-title' className='srt-only'>{title}</h2>
      <nav aria-label='Sibling project categories'>
        {slides?.length > 0 &&
          <SliderFlickity options={{ ...staticOptions, cellAlign: 'center' }} reloadOnUpdate={true} dynamicSlider={true}>
            {slides}
          </SliderFlickity>
        }
      </nav>
    </SectionLinksSlider>
  )
}

export const SectionLinksSlider = styled.section<{ $isMount: boolean }>`
  align-items: center;
  background-color: var(--color-navbar-background);
  display: flex;
  height: 60px;
  justify-content: center;
  opacity: ${({ $isMount }) => $isMount ? 1 : 0};
  overflow-x: hidden;
  padding: 10px 0;
  position: sticky;
  top:0;
  transition: opacity 250ms ease-in-out 150ms;
  width: 100vw;
  width: 100dvw;
  z-index: 3;

  nav {
    width: 100vw;
    width: 100dvw;

    a {
      opacity:.4;
      transition: opacity 250ms ease-in-out;
      
      &.active {
        opacity: 1;
      }
    }
  }

  &.empty {
    height: 0;
    margin: 0;
  }

  .flickity-cell {
    padding: 0 ${vw(12.5, 'mobile')} 0;

    ${mq.greaterThan('nexus7')} {
      padding: 0 ${vw(12.5, 'tablet')} 0;
    }

    ${mq.greaterThan('tablet')} {
      padding: 0 ${vw(25, 'desktop')} 0;
    }

    ${mq.greaterThan('desktop')} {
      padding: 0 25px 0;
    }

    &:first-child {
      padding-left: 30px;

      ${mq.greaterThan('tablet')} {
        padding-left: 60px;
      }
    }

    &:last-child {
      padding-right: 30px;

      ${mq.greaterThan('tablet')} {
        padding-right: 60px;
      }
    }
  }
`
